import * as React from 'react';
import './button_link.css';
import { button_no_hover, button_hover } from './button_link.styles';
import { Route, Link } from 'react-router-dom';
import { selectGeneric } from '../../store/actions/generic.actions';
import { bindActionCreators, Dispatch } from 'redux';
import { CustomAction, StoreState } from '../../store';
import { connect } from 'react-redux';

export interface Button_Props {
    text: string;
    color: string;
    text_color: string;
    className?: string;
    to: string;
    activeOnlyWhenExact?: boolean;

    route: string;

    navTo: Function;
}

export interface Button_State {
    hovering: boolean;
    clicked: boolean;
}

class ButtonLink extends React.PureComponent<Button_Props, Button_State> {



    constructor(props: Button_Props) {
        super(props)
        this.state = {
            hovering: false,
            clicked: false
       };
    }

    handleMouseEnter = () => this.setState({hovering : true});
    handleMouseLeave = () => this.setState({hovering : false});
    handleMouseUp = () => this.setState({clicked: false});
    handleMouseDown = () => this.setState({clicked: true});

    render() {
        return (
            <Route
                path={this.props.to}
                children={({ match }) => (
                    <Link to={this.props.to}>
                        <div
                        onMouseEnter={this.handleMouseEnter}
                        onMouseLeave={this.handleMouseLeave}
                        onMouseUp={this.handleMouseUp}
                        onMouseDown={this.handleMouseDown}
                        onClick={this.navTo.bind(this, this.props.to)}
                        className={this.props.className}
                        style={
                            (!this.state.hovering) ?
                            {...button_no_hover, 'backgroundColor': this.props.color, 'color': this.props.text_color} :
                            {...button_no_hover, ...button_hover, 'backgroundColor': this.props.color, 'color': this.props.text_color}
                        }>
                            {this.props.text}
                        </div>
                    </Link>
                    
                // <div className={match ? "active" : ""}>
                //     {match ? "> " : ""}
                    
                // </div>
                )}
            />
        )
    }

    navTo = (_to: string, event: any) => {
        this.props.navTo('ROUTE_SELECT', _to)
    }
}

export function mapStateToProps({ route }: StoreState) {
    return {
      route: route,
    }
}
  
export function mapDispatchToProps(dispatch: Dispatch<CustomAction>) {
    return bindActionCreators({
        navTo: selectGeneric
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ButtonLink);


// WEBPACK FOOTER //
// ./src/custom_components/button_link/button_link.component.tsx